export default __webpack_public_path__ + "static/media/ServerError.27e32cbc.svg";